import mitt from 'mitt';

const EVENT_SESSION_CONNECTED = 'EVENT_SESSION_CONNECTED';
const EVENT_SESSION_DISCONNECTED = 'EVENT_SESSION_DISCONNECTED';
const ws_emitter = mitt();

function start() {
    const websocket = new WebSocket(
        'ws://localhost:8000/ws/basic/'
    );

    websocket.onmessage = function (e) {
        const obj = JSON.parse(e.data);
        ws_emitter.emit(obj.event, obj.data);
    };

    websocket.onclose = function (e) {
        console.error('Socket closed: ' + e);
        setTimeout(function(){
            document.reload();
        }, 2000)
    };
}


export default {
    start,
    ws_emitter,
    EVENT_SESSION_CONNECTED,
    EVENT_SESSION_DISCONNECTED,
}